/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Scan_Tap_Focus_HintInputs */

const vi_mobile_scan_tap_focus_hint = /** @type {(inputs: Mobile_Scan_Tap_Focus_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chạm vào mã để lấy nét`)
};

/**

* @param {Mobile_Scan_Tap_Focus_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const mobile_scan_tap_focus_hint = /** @type {((inputs?: Mobile_Scan_Tap_Focus_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Scan_Tap_Focus_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_mobile_scan_tap_focus_hint(inputs)
});